import { styled } from 'parkdepot-shared/theme'

export const MyProfileButton = styled<'div', { $withMargin: boolean; $borderBottom?: boolean }>(
    'div',
    ({ $theme, $withMargin = true, $borderBottom = false }) => ({
        ...$theme.typography.ParagraphMedium,
        color: '#000',
        backgroundColor: $withMargin ? $theme.colors.white : 'transparent',
        justifyContent: 'space-between',
        display: 'flex',
        margin: $withMargin ? '0 -1.6rem' : '0',
        padding: '2.4rem 1.6rem',
        alignItems: 'center',
        cursor: 'pointer',
        borderTop: '1px solid #EAECF0',
        borderBottom: $borderBottom ? '1px solid #EAECF0' : 'none'
    })
)
export const ProfileButtonWrapper = styled('div', ({ $theme }) => ({
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
}))

export const ChevronRight = styled('i', ({ $theme }) => ({
    color: '#000',
    fontSize: '1.8rem'
}))

export const LeftIcon = styled('i', ({ $theme }) => ({
    fontSize: '1.8rem',
    color: $theme.colors.black
}))
